"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _index = require("../../styles/index.js");
var _index2 = require("../Icon/icons/IconChevronRight/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Icon = exports.Icon = (0, _styledComponents["default"])(_index2.IconChevronRight).attrs({
  size: 'small'
}).withConfig({
  displayName: "Icon",
  componentId: "sc-nedxh0-0"
})(["color:", ";margin-inline-start:", ";position:absolute;right:0;top:7px;[dir='rtl'] &{right:unset;align-self:center;left:0;transform:rotate(180deg);}"], (0, _index.cssColorValue)(_index.semanticColors.textSubdued), (0, _index.cssSpacing)('tighter-4', '4px'));